import { Button, Col, Form, Input, Modal, Row, Space } from "antd";
import { FC, useState } from "react";
import "./modalStyle.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { userActions } from "../../store/user";
import userSelectors from "../../store/user/selectors";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";

interface userInfoInterface {
  email: `${string | number}@${string}.${string}`;
}
const UserInfoForm: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const UserInfoModalvisible = useAppSelector(userSelectors.UserInfoModal);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const loader = useAppSelector(userSelectors.getLoader);
  const referralCode = localStorage.getItem("referral_code");
  const [userInfoForm] = Form.useForm();
  const onFinish = async (values: userInfoInterface) => {
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const nonce: any = localStorage.getItem("nonce");
      const address: any = localStorage.getItem("address");

      if (!nonce || !address) {
        setMessage("Missing nonce or address. Please try again.");
        return;
      }

      const signature = await signer.signMessage(nonce);

      if (signature) {
        dispatch(
          userActions.metamaskSignUp({
            email: values.email,
            address: address,
            signature: signature,
            referralCode: referralCode ? referralCode : ""
          })
        );
        navigate("/verify-account");
        userInfoForm.resetFields();
      } else {
        setMessage("Signature failed. Please try again.");
      }

      localStorage.removeItem("nonce");
      localStorage.removeItem("address");
    } catch (error) {
      console.error("Error during MetaMask sign-up:", error);
      setMessage("An error occurred. Please ensure MetaMask is connected.");
    }
  };

  return (
    <>
      <Modal
        title="Provide email to continue"
        visible={UserInfoModalvisible}
        transitionName=""
        centered={true}
        onCancel={() => {
          dispatch(userActions.userInfoModal({ visible: false }));
          userInfoForm.resetFields();
        }}
        footer={null}
      >
        <Form form={userInfoForm} layout={"vertical"} onFinish={onFinish}>
          <Row gutter={[0, 20]}>
            <Col span={24}>
              <Space direction="vertical">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Email field is required!" },
                    { type: "email", message: "Invaid email id!" },
                  ]}
                >
                  <Input
                    type="email"
                    className="email-input"
                    placeholder="Email address"
                  ></Input>
                </Form.Item>
              </Space>
            </Col>
            <Col span={24}>
              <Form.Item>
                <Button
                  className="submit-button"
                  loading={loader}
                  htmlType={"submit"}
                >
                  Continue with email
                </Button>
              </Form.Item>
            </Col>
            <Col span={24}>
              <p className="continue-text">
                By continuing you agree to haveto.com's <br />
                <span className="primary-color">User Agreement</span>,{" "}
                <span className="primary-color">Wallet Services Terms</span> and{" "}
                <span className="primary-color">Privacy policy</span>
              </p>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default UserInfoForm;
